module.exports = __webpack_public_path__ + "media/shinei2.4887758a.mp3";